import { useNavigate } from "react-router-dom";
import { BASE_URL, getToken } from "../api/api";

export default function useLogout() {
  const navigate = useNavigate();

  return () => {
    const token = getToken();
    if (token) void fetch(`${BASE_URL}/auth/logout`, {
      method: "POST", keepalive: true,
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: "{}",
    }).catch(() => {});
    // Clear auth info
    localStorage.removeItem("token");
    // Add other clears here if needed (user, device cache, etc.)

    // Go to login and replace history so Back doesn't return to protected pages
    navigate("/", { replace: true });
  };
}
